export var FILTER_TOOL_BAR_TEXTUAL_ACTIONS = {
  RESET: 'RESET',
  CLEAR: 'CLEAR'
};
export var DEFAULT_FILTER_BEHAVIOR = {
  GENERAL: 'GENERAL',
  PERSIST: 'PERSIST',
  PERSIST_LOCAL: 'PERSIST_LOCAL'
};